import { create } from 'zustand';

/**
 * Global data revision.
 *
 * The mock database is a mutable in-memory object, so a control that changes a
 * scenario, a feature flag or the fixtures has no way to tell the screens that
 * their data is stale. Every `useAsync` region reads this counter, so bumping
 * it re-runs every in-flight query and the whole app reflects the change
 * immediately — no page reload, no lost state.
 */
type DataVersionStore = {
  version: number;
  bump: () => void;
};

export const useDataVersion = create<DataVersionStore>((set) => ({
  version: 0,
  bump: () => set((s) => ({ version: s.version + 1 })),
}));

export function bumpDataVersion(): void {
  useDataVersion.getState().bump();
}
